
import { toRefs } from 'vue'
import { useRouter} from 'vue-router'
export default {
  props: {
    url: {
      type: String,
      detault: ''
    },
    type: {
      type: String,
      default: ''
    },
    data: {
      type: String,
      default: ''
    }
  },
  setup(props: any){
      const router = useRouter();
      const { url, type, data } = toRefs(props)
      const click_fn = () => {
        window.common.goTo(type.value, data.value, router)
      }
      return {
          url,
          click_fn
      }
  }
}
